// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerCol":"Footer_footerCol__C0ACA","footerLink":"Footer_footerLink__zoJJ6"};